import { HttpClient, HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ActivatedRoute } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AppName } from 'src/environments/environment-d'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { TapiService } from './tapi/tapi.service'

import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { SsrCookieService } from 'ngx-cookie-service-ssr'
import { SharedModule } from './shared/shared.module'

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http)
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
      return '';
  }
}


@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler},
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule,
  ],
  providers: [
    TapiService,
    SsrCookieService,
    {
      provide: 'APP_NAME',
      deps: [ActivatedRoute],
      useFactory: getAppName,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      deps: ['APP_NAME'],
      useFactory: (appName: AppName) => ({ appearance: environment.apps[appName].appearance }),
    },
  ],
})
export class AppModule {
}

// NOTE: REQUEST and RESPONSE injection token are not available during prerendering
// here we use query parameter ?app=<checklist|tokeet|...>
//
// 1. build-time: "app" values are specified in angular.json/prerender/options/routes
// 2. run-time: "app" values are added using nginx configs (mapping domains to app parameter)
function getAppName(route: ActivatedRoute) {
  let app
  // in browser - expect prerendered version to have body[data-app] attribute set
  if (typeof document !== 'undefined') {
    // NOTE: code initializing body[data-app] is in AppComponent.
    app = document?.body?.dataset?.app
    if (app) return app // prerendered
  }

  // when prerendering - read app value from query parameter (check nginx configs)
  route.queryParams.subscribe(params => {
    app = params.app
  })
  if (app) return app // prerendering
  // if (typeof document === 'undefined') return 'tokeet'
  throw new Error('undefined APP_NAME')
}
